export default __webpack_public_path__ + "static/media/FR.a0a16be9.svg";